import { useAtomValue } from 'jotai';

import { authStateAtom } from '$business/atoms/auth';

export function useAuthStateAtom() {
  return useAtomValue(authStateAtom);
}
